import { DialogTitle } from "@/components/ui/dialog"

interface Props {
  title: string
  description: string
  children?: React.ReactNode
}

/**
 * The white body of a step: its heading, its sub-heading, then whatever the
 * step asks for.
 *
 * Carries the dialog's accessible name, since the heading is the step's and
 * every step that has copy has exactly one.
 */
export function OnboardingPanel({ title, description, children }: Props) {
  return (
    <div className="px-9 pt-8">
      <DialogTitle className="mb-2.5 text-[25px] leading-tight font-semibold tracking-[-0.015em]">
        {title}
      </DialogTitle>
      <p className="text-muted-foreground mb-[22px] text-[15px] leading-[1.55]">
        {description}
      </p>
      {children}
    </div>
  )
}
